import { render, staticRenderFns } from "./IFrameRenderer.vue?vue&type=template&id=533ee6fd&scoped=true"
import script from "./IFrameRenderer.vue?vue&type=script&lang=js"
export * from "./IFrameRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ee6fd",
  null
  
)

export default component.exports